/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/send_medium'
export default icon
